import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PutAway03Actions, { PutAway03Types } from '../Stores/PutAway03/Actions';

const getAppStore = state => state.app;

export function* putAway03FetchPutAway03({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAway03Actions.putAway03FetchPutAway03Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexProcess/PUT_AWAY_03/0/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAway03Actions.putAway03FetchPutAway03Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAway03Actions.putAway03FetchPutAway03Loading(false));
  }
}

export function* putAway03CreatePutAway03({ hdrIds }) {
  try {
    yield put(PutAway03Actions.putAway03CreatePutAway03Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `putAway/createProcess/PUT_AWAY_03`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PutAway03Actions.putAway03CreatePutAway03Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAway03Actions.putAway03CreatePutAway03Loading(false));
  }
}

export function* putAway03GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodSheetDetail/update/${hdrId}`));
}

export function* putAway03NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodSheetDetail/create/${app.curDivisionId}`));
}

export const saga = [
  takeLatest(PutAway03Types.PUT_AWAY03_FETCH_PUT_AWAY03, putAway03FetchPutAway03),
  takeLatest(PutAway03Types.PUT_AWAY03_CREATE_PUT_AWAY03, putAway03CreatePutAway03),
  takeLatest(PutAway03Types.PUT_AWAY03_GO_TO_DOCUMENT, putAway03GoToDocument),
  takeLatest(PutAway03Types.PUT_AWAY03_NEW_DOCUMENT, putAway03NewDocument)
];
